import { Bell, CalendarDays, Inbox, NotebookPen, Settings, Sun } from 'lucide-react'
import type { ComponentType } from 'react'

/** Places ⌘K can jump to, with the G-sequences AppLayout listens for. */
export const GO_TO_PLACES: Array<{
  key: 'inbox' | 'today' | 'upcoming' | 'notifications' | 'notes' | 'settings'
  path: string
  Icon: ComponentType<{ className?: string }>
  shortcut?: string
}> = [
  { key: 'inbox', path: 'tasks', Icon: Inbox, shortcut: 'I' },
  { key: 'today', path: 'tasks/today', Icon: Sun, shortcut: 'T' },
  { key: 'upcoming', path: 'tasks/upcoming', Icon: CalendarDays, shortcut: 'U' },
  { key: 'notifications', path: 'notifications', Icon: Bell, shortcut: 'N' },
  { key: 'notes', path: 'notes', Icon: NotebookPen },
  { key: 'settings', path: 'settings', Icon: Settings },
]
